// src/components/ToastContainer.tsx
import React, { useEffect } from 'react';

import { useToastStore } from '~/libs/hooks/useToastStore';

const ToastContainer = () => {
    const toasts = useToastStore();

    if (typeof window === 'undefined') return null;

    return (
        <div className="toast-box">
            {toasts?.map((toast, index) => (
                <div key={index}>
                    <p key={toast.id}>{toast.message}</p>
                </div>
            ))}
        </div>
    );
};

export default ToastContainer;
